import { ProductsList } from './ProductsList';

export default ProductsList;
